import { Link } from 'react-router-dom';

type MicronLogoProps = {
  className?: string;
};

export default function MicronLogo({ className = 'h-10 w-auto' }: MicronLogoProps) {
  return (
    <Link to="/" className="inline-flex shrink-0">
      <img
        src="/micron-logo.png"
        alt="brixECOM"
        className={className}
      />
    </Link>
  );
}
